export const selectPromoValue = (state) => state.promoReducer.value;
